const messages = {
  time: {
    justNow: '刚刚',
    secondsAgo: '{n}秒前',
    minutesAgo: '{n}分钟前',
    hoursAgo: '{n}小时前',
    daysAgo: '{n}天前'
  },
  format: {
    wan: '{value}万'
  },
  common: {
    save: '保存',
    saving: '保存中...',
    enable: '启用',
    delete: '删除',
    all: '全部',
    loading: '加载中...',
    close: '关闭',
    refresh: '刷新',
    online: '在线',
    offline: '离线',
    unknownRole: '未知角色',
    gold: '金币'
  },
  layout: {
    appTitleKorea: '花狐-冒险岛韩服',
    windows: '窗口设置',
    scripts: '脚本配置',
    dataStats: '数据统计',
    globalSettings: '整体设置',
    logout: '退出登录',
    versionHistory: '版本更新历史',
    noVersionHistory: '暂无版本历史记录',
    versionLabel: '版本{version}',
    newUpdate: '新更新',
    versionNotice: '版本更新说明：'
  },
  koreaGlobal: {
    title: '整体设置 - 冒险岛韩服',
    subtitle: '测谎、钉钉机器人 Token 与群二维码会随脚本配置一起下发到设备端。',
    captchaSection: '自动过测谎',
    captchaPhone: '测谎手机号',
    captchaPhonePlaceholder: '选填，用于测谎相关联系',
    dingSection: '钉钉机器人',
    dingWarning:
      '若未填写自己的 access_token，告警会发到通用群，所有人的消息都在一起，容易比较乱。建议自行建群，按下面步骤添加机器人并填入 Token。',
    dingStep1: '在电脑或手机打开 钉钉，进入需要接收脚本消息的群聊。',
    dingStep2: '点击群右上角「⋯」→「群设置」→「机器人」→「添加机器人」。',
    dingStep3: '选择「自定义」机器人，按提示设置名称；安全设置按需选择（以钉钉页面为准）。',
    dingStep4: '创建成功后复制 Webhook 地址里 access_token= 后面的整段字符（也可直接粘贴完整 Webhook，保存时会自动提取）。',
    dingStep5: '将 Token 粘贴到下方输入框，点击页面右上角「保存」。',
    accessToken: 'access_token',
    tokenPlaceholder: '粘贴 access_token 或完整 Webhook 地址',
    tokenHint: '示例：https://oapi.dingtalk.com/robot/send?access_token=xxxxxxxx',
    qrLabel: '钉钉群二维码',
    qrCaption: '通用群二维码（未配置 Token 时消息会发到此群；建议自建群后勿依赖此群）',
    otherSection: '其他配置',
    autoUpdate: '自动更新',
    loadFail: '加载整体设置失败',
    saveFail: '保存失败',
    saveOk: '保存成功'
  },
  koreaConfig: {
    loading: '加载配置中...',
    createTitle: '创建配置 - 冒险岛韩服',
    editTitle: '编辑配置 - 冒险岛韩服',
    subtitle: '挂机地图、自动按键（内置 4 项不可删，还可自定义最多 7 个定时键）。',
    configName: '配置名称',
    configNamePlaceholder: '输入配置名称',
    configDesc: '配置描述',
    configDescPlaceholder: '输入配置描述（可选）',
    defaultNameLocked: '默认配置不允许修改名称',
    hangSection: '挂机设置',
    hangMap: '挂机地图',
    hangMapPlaceholder: '输入关键字筛选或下拉选择',
    hangMapNoMatch: '没有匹配的地图，换个关键词试试',
    hangMapNoData: '暂无地图数据',
    hangMapEmpty: '暂无选项：请在 adventure_hang_map_options 中为「冒险岛韩服」添加地图',
    otherSection: '其他设置',
    lieDetectServer: '测谎服务器',
    lieDetectServerPlaceholder: '192.168.31.x:7860',
    lieDetectServerHint: '示例：192.168.31.x:7860',
    centralComm: '中控通讯',
    autoClearBag: '自动清包',
    autoClearBagInterval: '自动清包间隔',
    autoClearBagIntervalHint: '随机区间 {min}～{max} 分钟，默认 30～40 分钟',
    minuteUnit: '分钟',
    autoHeal: '自动回血',
    autoBuyMedicine: '自动买药',
    medicineWhite: '白血瓶',
    medicineBlue: '蓝血瓶',
    medicinePetSnack: '宠物零食',
    needMedicineType: '开启自动买药时，请至少选择一种药品',
    teleportAttackInterval: '瞬移和攻击间隔',
    teleportAttackIntervalHint: '随机区间 {min}～{max} ms，默认 50～80 ms',
    msUnit: 'ms',
    scheduledLogout: '定时下线',
    scheduledLogoutEvery: '每',
    scheduledLogoutDuration: '下线时长',
    scheduledLogoutPosition: '角色位置',
    scheduledLogoutPosition1: '位置1',
    scheduledLogoutPosition2: '位置2',
    scheduledLogoutPosition3: '位置3',
    scheduledLogoutPositionRequired: '{label}：请选择位置1～位置3',
    scheduledLogoutIntervalLabel: '定时间隔（小时）',
    scheduledLogoutDurationLabel: '下线时长（分钟）',
    scheduledLogoutHint: '默认每 8 小时下线 60 分钟；间隔 {hourMin}～{hourMax} 小时，时长 {minMin}～{minMax} 分钟',
    hourUnit: '小时',
    numericRequired: '{label}：请填写有效数值',
    numericRange: '{label}：须在 {min}～{max} 之间',
    autoKeySection: '自动按键',
    autoKeyHint: '定时类按键在 {min}～{max} 秒区间随机触发；跳跃/瞬移/攻击为即时按键（无固定间隔）。',
    remarkName: '备注名',
    instantKey: '即时按键',
    secUnit: '秒',
    addTimedKey: '+ 添加定时按键（{count}/{max}）',
    saveConfig: '保存配置',
    updateConfig: '更新配置',
    viewOnly: '当前为只读查看模式',
    needConfigName: '请输入配置名称',
    needHangMap: '请选择挂机地图',
    hangMapLoadFail: '挂机地图列表加载失败（请确认 adventure_hang_map_options 中已维护「冒险岛韩服」）',
    keyRequired: '{label}：请选择 A～Z、空格或 Shift',
    intervalRequired: '{label}：请填写有效的间隔秒数',
    intervalRange: '{label}：间隔须在 {min}～{max} 秒之间',
    intervalOrder: '{label}：最短间隔不能大于最长间隔',
    bindWindowHint: '请记得在「窗口设置」里给窗口绑定该配置，否则脚本不会使用到此配置。',
    createOk: '配置创建成功。{hint}',
    updateOk: '配置更新成功。{hint}',
    loadFail: '加载配置失败: {msg}',
    notFound: '配置不存在',
    gameMismatch: '该配置属于「{game}」，与韩服配置页不匹配',
    presetPet: '宠物药水',
    presetJump: '跳跃键',
    presetTeleport: '瞬移键',
    presetAttack: '攻击键',
    mapSpecificSection: '地图专属配置',
    treasureIslandFightHint: '韩服抢夺宝物岛：各层打怪秒数（最少～最多，区间内随机）。',
    layerTop: '最上层',
    layerMid: '中层',
    layerBottom: '下层',
    fightMinSec: '最少打怪秒数',
    fightMaxSec: '最多打怪秒数',
    wildBearMapHint: '野熊的领地：巡逻次数与攻击长按时长（最少～最多，区间内随机）。',
    wildBearMidPatrol: '中层巡逻次数',
    wildBearBottomPatrol: '下层巡逻次数',
    countUnit: '次',
    attackHoldDuration: '攻击长按时长',
    attackHoldHint: '可调 {min}～{max} ms，默认 300～400 ms；若伤害偏低可适当调高',
    labC2MapHint: '韩服研究所C2：挂机模式、自动回图、攻击长按与移动概率等专属设置。',
    labC2HangMode: '挂机选项',
    labC2HangDefault: '默认',
    labC2HangPlatform: '站台站撸',
    labC2HangPatrol: '全图巡逻',
    labC2HangModeRequired: '请选择挂机选项',
    labC2AutoReturnMap: '自动回图',
    labC2PatrolDuration: '巡逻时长',
    labC2StandDuration: '站撸时长',
    labC2MoveProb: '移动概率',
    labC2WalkProb: '走路',
    labC2TeleportProb: '瞬移',
    labC2MoveProbHint: '走路与瞬移概率相加须为 100%，修改一项时另一项自动补齐；默认走路 10%、瞬移 90%',
    labC2MoveProbInvalid: '走路概率与瞬移概率须为 0～100 的整数',
    labC2MoveProbSum: '走路概率与瞬移概率相加必须等于 100%'
  },
  script: {
    viewUser: '正在偷偷查看用户 {user} 的配置（只读模式）',
    configCount: '配置数量：{count}/100',
    configLimitTip: '每个用户最多可创建100个配置',
    addConfig: '新增配置',
    colName: '配置名称',
    colGame: '游戏',
    colDesc: '描述',
    colShared: '共享状态',
    shared: '共享',
    private: '私有',
    colDevices: '关联的设备数',
    colCreated: '创建时间',
    colActions: '操作',
    empty: '暂无配置数据',
    emptyHint: '点击右上角「新增配置」按钮添加配置',
    copy: '复制配置',
    edit: '编辑',
    view: '查看',
    delete: '删除',
    defaultConfig: '默认配置',
    defaultConfigTip: '默认配置不允许删除'
  },
  window: {
    changelog: '更新日志',
    viewingUser: '正在查看：{user}',
    statLimit: '窗口上限',
    statTotal: '总窗口',
    statOnline: '在线',
    statOffline: '离线',
    statTotalGold: '总金币',
    grid: '网格',
    list: '列表',
    filterConfig: '筛选配置',
    filterGroup: '筛选分组',
    allConfigs: '全部配置',
    noGroup: '未分组',
    sortField: '排序字段',
    offlineOnly: '只看离线',
    batchOps: '批量操作',
    batchOpsCount: '批量操作 ({count})',
    changeConfig: '更换配置',
    setGroup: '设置分组',
    stopAll: '一键停止',
    runNow: '立刻执行',
    deleteSelected: '删除选中',
    perPage20: '20条/页',
    perPage50: '50条/页',
    perPage100: '100条/页',
    selectConfig: '请选择配置',
    selectGroup: '选择或输入分组名称',
    unknownRole: '未知角色',
    col: {
      select: '选择',
      window: '窗口',
      role: '角色',
      class: '职业',
      level: '等级',
      gold: '金币',
      yesterdayGold: '昨日金币',
      todayGold: '今日金币',
      version: '版本号',
      hpPotionCount: '血瓶数量',
      mpPotionCount: '蓝瓶数量',
      petSnackCount: '宠物零食数量',
      scrollCount: '卷轴数量',
      status: '状态',
      updateTime: '更新时间',
      config: '配置名称',
      group: '分类'
    },
    sort: {
      asc: '升序',
      desc: '降序'
    }
  }
}

export function t(key, params) {
  const keys = key.split('.')
  let val = messages
  for (const k of keys) {
    val = val?.[k]
    if (val === undefined) return key
  }
  if (typeof val !== 'string') return key
  if (!params) return val
  return val.replace(/\{(\w+)\}/g, (_, name) => (params[name] != null ? String(params[name]) : `{${name}}`))
}

export default messages
